import Ticket from '@/components/Ticket/Ticket';
import Question from '@/components/Question/Question';

export default class TicketArray {
    get all(): Ticket[] {
        return this._list;
    }

    private _list: Ticket[] = [];

    constructor(list?: TicketArray | Ticket[]) {
        this.fill(list);
    }

    public fill(list?: TicketArray | Ticket[]) {
        if (list && list instanceof TicketArray) {
            for (const item of list.all) {
                this.add(item);
            }
        } else if (list) {
            for (const item of list) {
                this.add(item);
            }
        }

        this.sort();
    }

    public refresh(list?: TicketArray | Ticket[]) {
        this.clear();
        this.fill(list);
    }

    public clear() {
        this._list.splice(0);
    }

    public add(item: Ticket) {
        this._list.push(new Ticket(item));
        this.sort();
    }

    public sort(): void {
        this._list = this._list.sort((a: Ticket, b: Ticket) => {
            if (a.num < b.num) {
                return -1;
            } else if (a.num > b.num) {
                return 1;
            } else {
                return 0;
            }
        });
    }
}
